module.exports = new __parcel__URL__("school-fundraiser.16cefea1.jpg").toString();